import React from 'react';
import { timelineColors, timelineFontWeight } from './tokens';

// Only shown at Week/Detail zoom, hidden entirely by the hide-labels toggle.
export const ItemLabelChip = React.memo(
  ({ x, y, maxWidth, label }: { x: number; y: number; maxWidth: number; label: string }) => (
    <div
      style={{
        position: 'absolute',
        left: x,
        top: y,
        transform: 'translateY(-50%)',
        maxWidth: Math.max(0, maxWidth - 6),
        zIndex: 3,
        pointerEvents: 'none',
        background: timelineColors.labelChipBg,
        backdropFilter: 'blur(1px)',
        border: `1px solid ${timelineColors.labelChipBorder}`,
        borderRadius: 4,
        padding: '2px 6px'
      }}
    >
      <div
        style={{
          fontSize: 11,
          fontWeight: timelineFontWeight.label,
          color: timelineColors.ink,
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis'
        }}
      >
        {label}
      </div>
    </div>
  )
);
